<template>
  <v-card class="px-2 mx-4 elevation-1 mb-2">
    <div class="full-width text-end">
      <v-menu open-on-hover bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mt-6 mr-4 mb-0" color="green" dark v-bind="attrs" v-on="on" outlined> Nhập/xuất Excel </v-btn>
        </template>

        <v-list>
          <v-list-item class="cursor-pointer" @click="showExcelDialog = !showExcelDialog">
            <v-list-item-title>Tải lên tệp Excel chứa điểm</v-list-item-title>
          </v-list-item>
          <v-list-item class="cursor-pointer" @click="exportExcelTemplate">
            <v-list-item-title>Tải xuống tệp Excel mẫu</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- <v-btn
        class="mt-6 mr-4 mb-0"
        v-if="$vuetify.breakpoint.mdAndUp"
        depressed
        dark
        color="green"
        outlined
        @click="showExcelDialog = !showExcelDialog"
      >
        <v-icon left>mdi-file-excel</v-icon> Thêm điểm theo tệp excel
      </v-btn> -->
    </div>

    <v-card-text>
      <template>
        <div>
          <div class="d-flex">
            <div v-if="filterParam.subject" class="text-h6 text-uppercase" style="color: #0d47a1">
              Môn {{ filterParam | _get('subject.title') }} {{ filterParam | _get('class.division.title') }} - Lớp
              {{ filterParam | _get('class.title') }} -
              {{ filterParam | _get('factor.title') }}
            </div>
            <!-- <span>Thao tác lần cuối: </span> -->
            <v-spacer />
            <v-btn @click="saveMarks" color="primary">Lưu</v-btn>
          </div>

          <div class="d-flex table-container pt-4">
            <v-form ref="form">
              <table class="mark-table">
                <thead>
                  <tr>
                    <th class="position-sticky-1">STT</th>
                    <th class="position-sticky-2">Học sinh</th>
                    <th class="position-sticky-3">Ngày sinh</th>
                    <th :colspan="100">
                      {{ $_get(filterParam, 'subject.markType') === 'mark' ? 'Điểm' : 'Nhận xét' }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, studentIndex) in studentMarks" :key="item.student.id">
                    <td class="position-sticky-1">{{ studentIndex + 1 }}</td>
                    <td class="px-2 py-0 position-sticky-2" style="text-align: left">
                      <CardStudentName :student="item.student" link />
                    </td>
                    <td class="position-sticky-3">{{ item.student.dob | ddmmyyyy }}</td>
                    <div v-if="$_get(filterParam, 'subject.markType') === 'mark'">
                      <td v-for="(mark, markIndex) in item.marks" :key="markIndex" class="mark-text-field ma-0 px-2">
                        <v-text-field
                          v-if="mark.markInDate"
                          class="mark-text-field"
                          v-model="mark.value"
                          hide-details
                          outlined
                          dense
                          type="number"
                          :rules="[$rules.markInput]"
                          :ref="`input-${studentIndex}-${markIndex}`"
                          @keydown.tab.prevent="tab(`input-${studentIndex + 1}-${markIndex}`)"
                        />
                        <v-tooltip bottom v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <div class="mark-text-field">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                @click="markInOtherDateClicked(item.student, mark)"
                                style="font-size: 16px; cursor: pointer"
                              >
                                {{ mark.value }}
                              </span>
                            </div>
                          </template>
                          <span>{{ mark.date | ddmmyyyy }}</span>
                        </v-tooltip>
                      </td>
                    </div>

                    <div v-else>
                      <td v-for="(mark, order) in item.marks" :key="order" class="evaluate-text-field ma-0 px-2">
                        <v-select
                          v-if="mark.markInDate"
                          :items="[
                            { text: 'Đạt', value: 1 },
                            { text: 'Chưa Đạt', value: 0 }
                          ]"
                          v-model="mark.value"
                          outlined
                          dense
                          hide-details
                          clearable
                          class="evaluate-text-field ma-0 px-2"
                        ></v-select>
                        <v-tooltip bottom v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <div class="evaluate-text-field">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                @click="markInOtherDateClicked(item.student, mark)"
                                class="mx-4"
                                style="font-size: 16px; white-space: nowrap; cursor: pointer"
                              >
                                {{ mark.value | getEvaluate }}
                              </span>
                            </div>
                          </template>
                          <span>{{ mark.date | ddmmyyyy }}</span>
                        </v-tooltip>
                      </td>
                    </div>
                  </tr>
                </tbody>
              </table>
            </v-form>
          </div>

          <!-- <div class="d-flex table-container pt-4">
            <v-form ref="form">
              <v-card class="elevation-1">
                <v-data-table
                  hide-default-footer
                  mobile-breakpoint="0"
                  sort-by="name"
                  :items="markStudents"
                  item-key="id"
                  :headers="headers"
                >
                  <template slot="top">
                    <div class="d-flex justify-end pa-2">
                      <v-btn @click="saveMarks" color="primary">Lưu</v-btn>
                    </div>
                  </template>
                  <template v-slot:[`item.index`]="{ index }">
                    {{ index + 1 }}
                  </template>
                  <template v-slot:[`item.student`]="{ item }">
                    <CardStudentName :student="item.student" link />
                  </template>
                  <template v-slot:[`item.dob`]="{ item }">
                    {{ item.student.dob | ddmmyyyy }}
                  </template>
                  <template v-slot:[`item.mark`]="{ item }">
                    <div v-if="filterParam.subject.markType === 'mark'" class="d-flex align-center">
                      <div v-for="(mark, index) in item.marks" :key="index" class="mark-text-field">
                        <v-text-field
                          v-if="mark.markInDate"
                          v-model="mark.value"
                          hide-details
                          outlined
                          dense
                          type="number"
                          :rules="[$rules.markInput]"
                        />
                        <v-tooltip max-width="250px" bottom v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                              @click="markInOtherDateClicked(item.student, mark)"
                              class="mx-4"
                              style="font-size: 16px; "
                            >
                              {{ mark.value }}
                            </span>
                          </template>
                          <span>{{ mark.date | ddmmyyyy }}</span>
                        </v-tooltip>
                      </div>
                    </div>

                    <div v-else class="d-flex align-center">
                      <div v-for="(mark, index) in item.marks" :key="index" class="evaluate-text-field">
                        <v-select
                          v-if="mark.markInDate"
                          :items="[
                            { text: 'Đạt', value: 1 },
                            { text: 'Chưa Đạt', value: 0 }
                          ]"
                          v-model="mark.value"
                          outlined
                          dense
                          hide-details
                        ></v-select>
                        <v-tooltip bottom v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <span
                              v-bind="attrs"
                              v-on="on"
                              @click="markInOtherDateClicked(item.student, mark)"
                              class="mx-4"
                              style="font-size: 16px; white-space: nowrap;"
                            >
                              {{ mark.value | getEvaluate }}
                            </span>
                          </template>
                          <span>{{ mark.date | ddmmyyyy }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </v-form>
          </div> -->
          <div class="d-flex justify-end mt-4">
            <v-btn color="primary" @click="saveMarks">Lưu</v-btn>
          </div>
        </div>
      </template>
    </v-card-text>
    <MarkEditDialog
      :state="markEditDialog"
      :student="selectedStudent"
      :mark="selectedMark"
      @updatedMark="refresh(filterParam)"
    />
    <MarkInputExcelDialog :filterParams="filterParam" :state="showExcelDialog" @done="refresh(filterParam)" />
  </v-card>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { get, chunk, orderBy } from 'lodash'
import MarkEditDialog from '@/modules/mark/MarkEditDialog.vue'
import { saveAs } from 'file-saver'
import Excel from 'exceljs'
import LoadAsset from 'load-asset'
import { Class } from '../../plugins/api'

export default {
  components: {
    CardStudentName,
    MarkEditDialog,
    MarkInputExcelDialog: () => import('@/modules/mark/MarkInputExcelDialog.vue')
  },
  data() {
    return {
      markStudents: [],
      markEditDialog: false,
      selectedStudent: {},
      selectedMark: {},
      showExcelDialog: false,
      headers: [
        { text: 'STT', value: 'index', width: 100, sortable: false },
        {
          text: 'Học sinh',
          value: 'student',
          sortable: false
        },
        {
          text: 'Ngày sinh',
          value: 'dob',
          width: 100,
          sortable: false
        },
        {
          text: 'Điểm',
          value: 'mark',
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  props: {
    // marks: Array,
    // factor: Object
  },
  methods: {
    ...mapActions('ClassMarkInput', ['fetchMarks', 'createMark', 'updateMark', 'removeMark']),
    async refresh(query) {
      this.$loading.active = true
      await this.fetchMarks(query)
      this.markStudents = this.studentMarks
      this.$loading.active = false
    },
    async saveMarks() {
      if (!this.$refs.form.validate()) {
        this.$alert.error('Điểm phải trong khoảng từ 0 đến 10')
        return
      }
      const groups = chunk(this.markStudents, 3)
      for (let subMarkStudents of groups) {
        const promises = subMarkStudents.reduce((acc, cur) => {
          const markPromies = cur.marks.map(({ id, value, rawValue }) => {
            if (id) {
              if (rawValue !== value) {
                if (value) {
                  return this.updateMark({ id, value })
                } else {
                  return this.removeMark(id)
                }
              } else Promise.resolve()
            } else {
              if (parseFloat(value) >= 0) {
                return this.createMark({
                  student: cur.student.id,
                  value: value,
                  class: get(this.filterParam, 'class.id'),
                  subject: get(this.filterParam, 'subject'),
                  grade: get(this.filterParam, 'class.grade.id'),
                  semester: get(this.filterParam, 'semester.id'),
                  factor: get(this.filterParam, 'factor.id'),
                  date: get(this.filterParam, 'date'),
                  staff: this.profile.id,
                  teacher: this.profile.id
                })
              } else {
                Promise.resolve()
              }
            }
          })
          return [...acc, ...markPromies]
        }, [])

        try {
          this.$loading.active = true
          await Promise.all(promises)
          this.$alert.success('Lưu điểm thành công')
        } catch (error) {
          this.$alert.error('Đã có lỗi xảy ra ' + error)
        } finally {
          this.$loading.active = false
        }
      }

      await this.refresh(this.filterParam)
    },
    markInOtherDateClicked(student, mark) {
      this.selectedStudent = student
      this.selectedMark = mark
      this.markEditDialog = !this.markEditDialog
    },
    tab(ref) {
      // tab theo chieu doc
      this.$refs[ref] && this.$refs[ref][0].focus()
    },

    async exportExcelTemplate() {
      this.$loading.active = true
      try {
        const workbook = new Excel.Workbook()
        const buffer = await LoadAsset({ url: '/mark-template.xlsx', type: 'binary' })
        await workbook.xlsx.load(buffer)
        const worksheet = workbook.worksheets[0]

        const classData = await Class.fetchOne(this.filterParam.class.id)
        let students = classData.students.filter(s => s.status === 'active')
        students = orderBy(students, ['nameToNumber'], ['asc'])
        const filters = this.$options.filters

        students.map((student, index) => {
          const rowIndex = index + 2
          worksheet.getCell(`A${rowIndex}`).value = student.name
          worksheet.getCell(`B${rowIndex}`).value = filters.getStudentCode(student.code)
          worksheet.getCell(`C${rowIndex}`).value = filters.ddmmyyyy(student.dob)
          worksheet.getCell(`D${rowIndex}`).value = this.filterParam.class.title
          worksheet.getCell(`E${rowIndex}`).value = filters.factorType(this.filterParam.factor.type)
        })

        const excelBuffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        saveAs(
          blob,
          `${this.filterParam.class.title}-DanhSachHS-Diem${this.$options.filters.factorType(
            this.filterParam.factor.type
          )}.xlsx`
        )
      } catch (error) {
        console.error(error)
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  computed: {
    ...mapState('ClassMarkInput', ['filterParam']),
    ...mapGetters('ClassMarkInput', ['studentMarks']),
    ...mapGetters('auth', ['profile']),

    columnNo() {
      return this.factor.quantity
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.mark-text-field {
  width: 100px;
  // margin: 4px;
}
.evaluate-text-field {
  width: 150px;
  // margin: 4px;
}

.mark-table {
  td,
  tr,
  th {
    border: 1px solid #e0e0e0;
  }
  td,
  th {
    padding: 14px 20px;
    text-align: center;
  }
  color: #212121;
  border-collapse: collapse;
  width: 100%;
}
.table-container {
  overflow: auto;
  max-width: 100%;
}

.position-sticky-1 {
  position: sticky;
  left: -5px;
  z-index: 1;
  background-color: white;
}
.position-sticky-2 {
  position: sticky;
  left: 50px;
  z-index: 1;
  background-color: white;
}
.position-sticky-3 {
  position: sticky;
  left: 200px;
  z-index: 1;
  background-color: white;
}
</style>
